// ============================================================================
// STRAIGHT SIGHT — SITE CONTENT (edit this file to update the website copy)
// This is the simple "CMS": change text, contact details, stats, testimonials,
// gallery images and eligibility statements here — no other code changes needed.
// See /app/LAUNCH_GUIDE.md for full instructions.
// ============================================================================

export const IMAGES = {
  heroExam: "https://customer-assets-wrfwihn1.emergentagent.net/job_vision-redesign-1/artifacts/cbuok9yp_WhatsApp%20Image%202022-10-10%20at%206.57.41%20PM%20%281%29.webp",
  heroPhoropter: "https://images.unsplash.com/photo-1758656321505-95bf802f9a4c?auto=format&fit=crop&w=900&q=80",
  classroom: "https://images.unsplash.com/photo-1577896851231-70ef18881754?auto=format&fit=crop&w=1100&q=80",
  classroom2: "https://images.unsplash.com/photo-1574130303188-31a915382726?auto=format&fit=crop&w=1000&q=80",
  glassesGirlPink: "https://images.unsplash.com/photo-1593194777536-e155e6d100b2?auto=format&fit=crop&w=800&q=80",
  glassesBoy: "https://images.pexels.com/photos/20437260/pexels-photo-20437260.jpeg?auto=compress&cs=tinysrgb&w=800",
  glassesGirlRed: "https://images.pexels.com/photos/36079985/pexels-photo-36079985.jpeg?auto=compress&cs=tinysrgb&w=800",
  glassesGirlBlack: "https://images.unsplash.com/photo-1601782744132-f08f10b3343e?auto=format&fit=crop&w=800&q=80",
  preschool: "https://images.unsplash.com/photo-1614113036347-9f60df80730a?auto=format&fit=crop&w=800&q=80",
  preschool2: "https://images.unsplash.com/photo-1627764940620-90393d0e8c34?auto=format&fit=crop&w=800&q=80",
  teacher: "https://images.unsplash.com/photo-1554721299-e0b8aa7666ce?auto=format&fit=crop&w=800&q=80",
  teacher2: "https://images.unsplash.com/photo-1589206946274-929e4da3996b?auto=format&fit=crop&w=800&q=80",
  eyeTestChild: "https://customer-assets-wrfwihn1.emergentagent.net/job_vision-redesign-1/artifacts/wj6ertr7_Eagle%20Vale%201.JPEG",
  eyeTestChild2: "https://images.pexels.com/photos/5996651/pexels-photo-5996651.jpeg?auto=compress&cs=tinysrgb&w=1000",
  ctaSchool: "https://images.unsplash.com/photo-1577896851231-70ef18881754?auto=format&fit=crop&w=1600&q=80",
  // Real Straight Sight program photos & brand
  ssFitting: "https://customer-assets-wrfwihn1.emergentagent.net/job_vision-redesign-1/artifacts/cbuok9yp_WhatsApp%20Image%202022-10-10%20at%206.57.41%20PM%20%281%29.webp",
  ssClassroom: "https://customer-assets-wrfwihn1.emergentagent.net/job_vision-redesign-1/artifacts/wj6ertr7_Eagle%20Vale%201.JPEG",
  ssRoom: "https://customer-assets-wrfwihn1.emergentagent.net/job_vision-redesign-1/artifacts/nxgze23d_Eagle%20Vale%202.JPEG",
  ssDeliver: "https://customer-assets-wrfwihn1.emergentagent.net/job_vision-redesign-1/artifacts/f902g3zc_WhatsApp%20Image%202022-10-10%20at%206.57.37%20PM.webp",
  ssLabelling: "https://customer-assets-wrfwihn1.emergentagent.net/job_vision-redesign-1/artifacts/475ygjum_WhatsApp%20Image%202022-10-10%20at%206.57.39%20PM%20%281%29.webp",
  logo: "https://customer-assets-wrfwihn1.emergentagent.net/job_vision-redesign-1/artifacts/lijvfrfv_straight-sight-logo.webp",
  logoOnWhite: "https://customer-assets-wrfwihn1.emergentagent.net/job_vision-redesign-1/artifacts/gr2wppu0_straight-sight-logo-onwhite.webp",
  // Educational demonstration graphics
  eduChart: "https://customer-assets-wrfwihn1.emergentagent.net/job_vision-redesign-1/artifacts/qa9fp88n_eye%20teaming.jpg",
  eduTeaming: "https://customer-assets-wrfwihn1.emergentagent.net/job_vision-redesign-1/artifacts/udect4lk_eye%20teaming.gif",
  eduTracking: "https://customer-assets-wrfwihn1.emergentagent.net/job_vision-redesign-1/artifacts/m4cq82ty_eye%20tracking.gif",
  glassesRange: "https://customer-assets-wrfwihn1.emergentagent.net/job_vision-redesign-1/artifacts/bhx0ki92_free%20glasses%20range.jpg",
  ssTesting: "https://customer-assets-wrfwihn1.emergentagent.net/job_vision-redesign-1/artifacts/f1e58kvd_SS%20testing%201.jpg",
  glassesBoxes: "https://customer-assets-wrfwihn1.emergentagent.net/job_vision-redesign-1/artifacts/tvk4swao_glasses%20photo4.webp",
  ssDelivery: "https://customer-assets-wrfwihn1.emergentagent.net/job_vision-redesign-1/artifacts/6pvyt2ms_IMG_8033.webp",
  groupGlasses: "https://customer-assets-wrfwihn1.emergentagent.net/job_vision-redesign-1/artifacts/ywrw5659_group%20photo%20after%20glasses.webp",
  teensGroup: "https://customer-assets-wrfwihn1.emergentagent.net/job_vision-redesign-1/artifacts/4cyp9bg4_students%20with%20glasses%20on.jpg",
  teensTable: "https://customer-assets-wrfwihn1.emergentagent.net/job_vision-redesign-1/artifacts/591v789f_students%20with%20glasses%20on%20.jpg",
  glassesSelection: "https://customer-assets-wrfwihn1.emergentagent.net/job_vision-redesign-1/artifacts/ikhvk8z8_glasses%20selsection%201.jpg",
  glassesDelivery3: "https://customer-assets-wrfwihn1.emergentagent.net/job_vision-redesign-1/artifacts/qupremvt_glasses%20delivery3.webp",
  pyjamaDay: "https://customer-assets-wrfwihn1.emergentagent.net/job_vision-redesign-1/artifacts/aieqy5r4_WhatsApp%20Image%202026-08-07%20at%202.53.24%20PM.jpeg",
  thanksNote: "https://customer-assets-wrfwihn1.emergentagent.net/job_vision-redesign-1/artifacts/s1tcflk5_bidwill%20public%20thanks.png",
  glassesCollage: "https://customer-assets-wrfwihn1.emergentagent.net/job_vision-redesign-1/artifacts/214c5t2u_481767247_634864659289019_3683536180134306362_n.jpg",
};

// Hero video (background-style: autoplay, muted, looping).
// Paste the uploaded MP4 URL into `src`. Leave src empty ("") to hide the section.
export const VIDEO = {
  src: "https://customer-assets-wrfwihn1.emergentagent.net/job_vision-redesign-1/artifacts/5035059306f08e52_775d6aa3-fb17-4bca-b117-ca1d4f23d6f0.mp4",
  poster: "https://customer-assets-wrfwihn1.emergentagent.net/job_vision-redesign-1/artifacts/ywrw5659_group%20photo%20after%20glasses.webp",
  overline: "See it in action",
  heading: "A Straight Sight program, start to finish",
  subheading: "From friendly assessments to the moment a student receives their free glasses — right at school.",
};


export const CONTACT = {
  businessName: "Straight Sight Pty Ltd",
  location: "",
  address: "Shop 2, 96-98 Columbine Avenue, Punchbowl NSW 2196",
  phone: "0400 630 986",
  phoneIntl: "+61400630986",
  email: "admin@straightsight.com.au",
  email2: "eddy@straightsight.com.au",
  hours: "Mon–Fri · 9:00am – 5:00pm",
  mapsEmbed:
    "https://www.google.com/maps?q=Shop%202%2C%2096-98%20Columbine%20Avenue%2C%20Punchbowl%20NSW%202196&output=embed",
  social: { facebook: "https://www.facebook.com/StraightSight", instagram: "", linkedin: "" }, // confirm exact Facebook URL; add IG/LinkedIn when ready
};

// VERIFIED STATS — placeholders. Replace [Insert verified number] with real,
// verified figures supplied by Straight Sight before publishing.
export const STATS = [
  { value: 39798, placeholder: "[Insert]", suffix: "+", label: "Students assessed" },
  { value: 138, placeholder: "[Insert]", suffix: "+", label: "Schools supported" },
  { value: 11939, placeholder: "[Insert]", suffix: "+", label: "Glasses provided" },
  { value: 14, placeholder: "[Insert]", suffix: "", label: "Years serving communities" },
];

export const INSIGHTS = {
  needGlassesRatio: "1 in 4",
  intro: "Across our recent school programs, comprehensive assessments consistently identify a significant number of students who need glasses — many for the very first time.",
  years: [
    { year: "2023", tested: 9576, schools: 46, glasses: 2408 },
    { year: "2024", tested: 8562, schools: 61, glasses: 2379 },
  ],
};

export const NAV = [
  { label: "Home", id: "home" },
  { label: "School Vision Testing", id: "school-testing" },
  { label: "How It Works", id: "how-it-works" },
  { label: "Our Services", id: "services" },
  { label: "Orthoptic Therapy", id: "therapy" },
  { label: "About", id: "about" },
  { label: "FAQs", id: "faqs" },
  { label: "Contact", id: "contact" },
];

export const AUDIENCES = [
  { icon: "GraduationCap", title: "Primary Schools", note: "Early detection for young learners" },
  { icon: "BookOpen", title: "High Schools", note: "Support through key study years" },
  { icon: "Baby", title: "Childcare Centres", note: "Age-appropriate early screening" },
  { icon: "Users", title: "Parents & Families", note: "Clear results and next steps" },
];

export const BENEFITS = [
  { icon: "MapPin", title: "Convenient for schools", body: "The professional team comes directly to the school or childcare centre." },
  { icon: "ClipboardCheck", title: "Comprehensive assessments", body: "Students are assessed across several important areas of vision and eye function." },
  { icon: "Users", title: "Two eye-care professions", body: "The program brings together the complementary skills of Orthoptists and Optometrists." },
  { icon: "Mail", title: "Clear parent communication", body: "Parents receive information about their child's assessment results." },
  { icon: "FileText", title: "Useful school reporting", body: "Teachers and school leadership receive appropriate summaries to support student care." },
  { icon: "Glasses", title: "Glasses assistance", body: "Eligible students requiring glasses can select frames, with completed glasses organised and delivered through the program." },
];

export const STEPS = [
  { n: "01", title: "School enquiry", body: "The school or childcare centre submits an enquiry and discusses its needs with the Straight Sight team." },
  { n: "02", title: "Program planning", body: "Straight Sight coordinates suitable dates, consent requirements, student numbers, available facilities and communication materials." },
  { n: "03", title: "Orthoptic assessment", body: "Orthoptists assess areas including visual acuity, eye posture, eye teaming, eye focusing, eye tracking, stereo vision and relevant visual processing concerns." },
  { n: "04", title: "Optometric assessment", body: "Optometrists examine the health of the front and back of the eyes and perform a full refraction to identify whether glasses may be required." },
  { n: "05", title: "Reports & recommendations", body: "Parents receive their child's results and recommendations. Where appropriate, teachers receive a concise summary and school leadership receives an overall program summary. Student health information is handled carefully and shared only through appropriate processes." },
  { n: "06", title: "Glasses selection & delivery", body: "Students who require glasses can select frames at school. Straight Sight organises the appropriate lenses and delivers the completed glasses — completely free — through the school program." },
];

export const ASSESSMENT = [
  { title: "Visual acuity", body: "How clearly the student sees at near and distance." },
  { title: "Refraction", body: "Whether glasses are required and whether an existing prescription remains appropriate." },
  { title: "Eye posture", body: "Whether an eye turn is present and its type or severity." },
  { title: "Eye teaming", body: "How effectively both eyes point and work together." },
  { title: "Eye focusing", body: "How the eyes maintain clarity when looking at near and distant objects." },
  { title: "Eye tracking", body: "How smoothly and accurately the eyes move during activities such as reading." },
  { title: "Stereo vision", body: "The ability to use both eyes together to perceive depth and three-dimensional vision." },
];

export const SERVICES = [
  { icon: "School", title: "School & childcare vision programs", body: "Comprehensive vision assessments delivered within schools and childcare environments." },
  { icon: "Baby", title: "Paediatric orthoptic assessments", body: "Child-friendly assessments designed to gather meaningful information about a child's vision and eye coordination in an engaging environment." },
  { icon: "Eye", title: "Amblyopia management", body: "Assessment and management support for amblyopia, commonly called lazy eye. Treatment recommendations may include glasses, patching or other clinically appropriate approaches in coordination with relevant eye-care professionals." },
  { icon: "Target", title: "Strabismus & eye-turn assessment", body: "Assessment of eye posture, eye alignment and how effectively the eyes work together." },
  { icon: "Activity", title: "Orthoptic vision therapy", body: "Individualised programs designed to improve particular visual skills and support comfortable binocular vision where clinically appropriate." },
  { icon: "Monitor", title: "Digital eye-strain guidance", body: "Assessment and practical guidance for people experiencing visual discomfort associated with extended computer or smart-device use." },
  { icon: "Move", title: "Eye tracking & focusing support", body: "Assessment of eye movement, focusing and teaming skills that may affect visual comfort during near work." },
  { icon: "HeartHandshake", title: "Low-vision & visual rehabilitation support", body: "Orthoptic support for people with low vision or visual difficulties associated with neurological conditions, where suitable." },
];

export const THERAPY_GOALS = [
  "Help balance vision between the eyes",
  "Improve eye teaming",
  "Support visual comfort",
  "Develop binocular visual function",
];

export const CONSULTATION = [
  "Review of visual and relevant health history",
  "Full visual acuity assessment",
  "Refraction and review of current glasses",
  "Eye-posture assessment",
  "Eye-teaming assessment",
  "Eye-focusing assessment",
  "Eye-tracking assessment",
  "Stereoacuity and depth-perception assessment",
  "Discussion of findings and recommended next steps",
];

export const OPTOMETRIST = [
  "Assesses vision and refractive error",
  "Prescribes glasses and contact lenses",
  "Examines eye health",
  "Detects and manages certain eye conditions",
  "Refers to or works with Ophthalmologists when required",
];

export const ORTHOPTIST = [
  "Assesses eye alignment and eye movements",
  "Manages binocular-vision problems",
  "Assesses eye teaming, focusing and tracking",
  "Supports patients with amblyopia and strabismus",
  "Works in hospitals, ophthalmology clinics, private practices and rehabilitation settings",
  "Supports people with neurological or low-vision needs where appropriate",
];

export const WHO_WE_HELP = [
  "Preschool children",
  "Primary-school students",
  "Secondary-school students",
  "Children with suspected vision concerns",
  "Students experiencing difficulty with visual classroom tasks",
  "Children with amblyopia or eye turns",
  "People experiencing digital eye strain",
  "Patients requiring orthoptic or visual rehabilitation support",
];

// TESTIMONIALS — set placeholder:false for genuine, approved quotes. Placeholder
// entries show a "Placeholder" badge and should be replaced before publishing.
export const TESTIMONIALS = [
  { quote: "A big thank you to Straight Sight, who recently provided every student at our school with a free, comprehensive vision assessment. This week, 69 of our students received a FREE pair of glasses! We're grateful to Straight Sight and the generous support of the Essilor Vision Foundation and Opticare for providing our students with much-needed holistic eye care that will have a positive impact on their learning and wellbeing.", name: "A participating public school", role: "School newsletter", placeholder: false },
  { quote: "We had fantastic results with our recent vision testing from the team at Straight Sight. They tested 647 of our students, and 224 of them required glasses — students were able to choose these from their FREE range.", name: "A participating high school", role: "School newsletter", placeholder: false },
  { quote: "I want to thank you and your team for the amazing work you've done with our students over the past few weeks. Such a fantastic initiative to support our families who would not otherwise have access to these services.", name: "Natalie", role: "Senior Leader, Community Engagement", placeholder: false },
  { quote: "We are definitely keen to get this happening again.", name: "Paul", role: "School Principal", placeholder: false },
  { quote: "We are so thrilled with the work of your staff, especially Joie — they have been incredible with the kids, communicating with me and supporting us through this process.", name: "Amanda", role: "Teacher", placeholder: false },
  { quote: "Great program for free glasses.", name: "Nicholas S.", role: "Parent", placeholder: false },
  { quote: "Free vision test and free glasses — and guess what, it's real!", name: "Eddy J.", role: "Parent", placeholder: false },
  { quote: "Bringing healthy sight to so many students across New South Wales is a gift in itself — but on our last day of testing, the lovely staff at one of our schools surprised us with a box of chocolates. We're so grateful for the warm welcome, had an amazing time, and can't wait for the students to receive their glasses.", name: "The Straight Sight Team", role: "From our team", placeholder: false },
];

export const FAQS = [
  { q: "Who can participate in the school vision program?", a: "Programs can be discussed with primary schools, secondary schools, high schools, preschools and childcare centres. Eligibility and delivery arrangements should be confirmed with Straight Sight." },
  { q: "Does the school need special equipment?", a: "Straight Sight will advise the school about the room, space and facilities needed before the scheduled program." },
  { q: "Are the assessments free?", a: "Yes. All vision assessments are fully bulk billed through Medicare, so there is no cost to students or families." },
  { q: "Are glasses free?", a: "Yes. Students who require glasses receive their frames and lenses completely free through the program." },
  { q: "Will parents receive the results?", a: "Yes. Parents or caregivers receive information about their child's assessment results and any recommended next steps." },
  { q: "What information does the school receive?", a: "Appropriate summaries may be provided to teachers and school leadership in accordance with consent, privacy and clinical requirements." },
  { q: "How long does each assessment take?", a: "Please contact Straight Sight for the current average appointment duration." },
  { q: "Can childcare centres participate?", a: "Yes. Straight Sight can discuss age-appropriate program options with childcare centres and preschools." },
  { q: "What happens when a concern is identified?", a: "The parent or caregiver receives information about the finding and any recommended treatment, glasses, follow-up or referral." },
  { q: "How does a school book a program?", a: "The school can complete the website enquiry form, call Straight Sight or send an email." },
];

// LIVE AVAILABILITY — edit these to reflect current booking availability.
// state options: "open" (green), "limited" (amber), "full" (grey).
export const AVAILABILITY = {
  status: "Now Booking",
  intro: "We're currently taking bookings for upcoming terms. Places are limited each term, so secure your school's visit early.",
  terms: [
    { term: "Term 4 2026", state: "limited", note: "Limited places" },
    { term: "Term 1 2027", state: "open", note: "Now booking" },
    { term: "Term 2 2027", state: "open", note: "Now booking" },
  ],
};

// REGISTRATIONS & MEMBERSHIPS — edit wording to match your exact credentials.
// Keep statements accurate; add specific body/registration names once confirmed.
export const CREDENTIALS = [
  { icon: "BadgeCheck", title: "AHPRA registered", body: "Our Optometrists are registered with the Australian Health Practitioner Regulation Agency (AHPRA)." },
  { icon: "ShieldCheck", title: "Working With Children Checks", body: "All team members hold current Working With Children Checks for working in schools and childcare settings." },
  { icon: "FileCheck", title: "Fully insured", body: "Covered by public liability and professional indemnity insurance." },
];

export const FRAME_CATALOGUE_URL = "https://customer-assets-wrfwihn1.emergentagent.net/job_vision-redesign-1/artifacts/qio87xn2_Catalogue%20MASS%20Frame%20Catalogue%202016%20-%20785.10%20%281%29.pdf";

// Frame catalogue pages rendered to images (in /public/frames). Swap for your
// own plain frame photos when available.
export const FRAME_PAGES = [
  { src: "/frames/page-09.png", label: "Kids" },
  { src: "/frames/page-08.png", label: "Adolescents" },
  { src: "/frames/page-03.png", label: "Adults · Unisex" },
  { src: "/frames/page-04.png", label: "Adults · Women" },
  { src: "/frames/page-05.png", label: "Adults · Women" },
  { src: "/frames/page-06.png", label: "Adults · Men" },
  { src: "/frames/page-07.png", label: "Adults · Men" },
];

export const ORG_TYPES = ["Childcare centre", "Preschool", "Primary school", "Secondary school", "Combined school", "Other"];

export const SERVICE_OPTIONS = [
  "Paediatric orthoptic assessment",
  "Amblyopia management",
  "Strabismus / eye-turn assessment",
  "Orthoptic vision therapy",
  "Digital eye-strain guidance",
  "Low-vision / visual rehabilitation support",
  "General enquiry",
];


// SUBURBS REACHED — shown as pins on the map (suburb only, no school names,
// to protect school relationships). lat/lng are approximate suburb centres;
// look up exact coordinates on Google Maps (right-click → lat, lng).
// Add or remove suburbs here as your program grows.
export const SCHOOLS = [
  { name: "Kellyville", lat: -33.711, lng: 150.944 },
  { name: "Strathfield", lat: -33.879, lng: 151.094 },
  { name: "Airds", lat: -34.087, lng: 150.833 },
  { name: "Bankstown", lat: -33.918, lng: 151.035 },
  { name: "Liverpool", lat: -33.923, lng: 150.924 },
  { name: "Ambarvale", lat: -34.09, lng: 150.798 },
  { name: "Ashcroft", lat: -33.921, lng: 150.893 },
  { name: "Auburn", lat: -33.849, lng: 151.025 },
  { name: "Banksmeadow", lat: -33.956, lng: 151.215 },
  { name: "Bass Hill", lat: -33.907, lng: 150.997 },
  { name: "Belmore", lat: -33.918, lng: 151.089 },
  { name: "Greystanes", lat: -33.826, lng: 150.943 },
  { name: "Berrima", lat: -34.487, lng: 150.333 },
  { name: "Bidwill", lat: -33.736, lng: 150.829 },
  { name: "Birrong", lat: -33.893, lng: 151.023 },
  { name: "Blacktown", lat: -33.76, lng: 150.906 },
  { name: "Blairmount", lat: -34.047, lng: 150.802 },
  { name: "Bossley Park", lat: -33.868, lng: 150.885 },
  { name: "Bowral", lat: -34.477, lng: 150.418 },
  { name: "Goulburn", lat: -34.754, lng: 149.72 },
  { name: "Bundanoon", lat: -34.656, lng: 150.296 },
  { name: "Busby", lat: -33.921, lng: 150.877 },
  { name: "Cabramatta", lat: -33.894, lng: 150.937 },
  { name: "Canterbury", lat: -33.911, lng: 151.118 },
  { name: "Chester Hill", lat: -33.887, lng: 150.999 },
  { name: "North St Marys", lat: -33.757, lng: 150.786 },
  { name: "Mount Druitt", lat: -33.77, lng: 150.818 },
  { name: "Shalvey", lat: -33.725, lng: 150.833 },
  { name: "Chullora", lat: -33.893, lng: 151.063 },
  { name: "Claymore", lat: -34.041, lng: 150.793 },
  { name: "Condell Park", lat: -33.92, lng: 151.013 },
  { name: "Doonside", lat: -33.766, lng: 150.87 },
  { name: "Eagle Vale", lat: -34.0556, lng: 150.7986 },
  { name: "Ermington", lat: -33.81, lng: 151.05 },
  { name: "Fairfield", lat: -33.872, lng: 150.956 },
  { name: "Gledswood Hills", lat: -34.011, lng: 150.757 },
  { name: "Hurstville", lat: -33.967, lng: 151.102 },
  { name: "Granville", lat: -33.836, lng: 151.011 },
  { name: "Greenacre", lat: -33.902, lng: 151.057 },
  { name: "Lakemba", lat: -33.92, lng: 151.075 },
  { name: "Heckenberg", lat: -33.916, lng: 150.888 },
  { name: "Hill Top", lat: -34.34, lng: 150.499 },
  { name: "Hobartville", lat: -33.607, lng: 150.769 },
  { name: "Horsley Park", lat: -33.838, lng: 150.848 },
  { name: "Ingleburn", lat: -34.0, lng: 150.862 },
  { name: "Punchbowl", lat: -33.929, lng: 151.055 },
  { name: "Yagoona", lat: -33.904, lng: 151.024 },
  { name: "Kanwal", lat: -33.236, lng: 151.504 },
  { name: "Camden", lat: -34.053, lng: 150.697 },
  { name: "Tahmoor", lat: -34.222, lng: 150.5925 },
  { name: "Kentlyn", lat: -34.057, lng: 150.848 },
  { name: "Kingsgrove", lat: -33.935, lng: 151.101 },
  { name: "Koonawarra", lat: -34.53, lng: 150.832 },
  { name: "Lansvale", lat: -33.906, lng: 150.954 },
  { name: "Warrawong", lat: -34.487, lng: 150.893 },
  { name: "Lethbridge Park", lat: -33.735, lng: 150.802 },
  { name: "Peakhurst", lat: -33.962, lng: 151.062 },
  { name: "Burwood Heights", lat: -33.893, lng: 151.103 },
  { name: "Campbelltown", lat: -34.063, lng: 150.814 },
  { name: "Marrickville", lat: -33.911, lng: 151.156 },
  { name: "Mayfield", lat: -32.896, lng: 151.735 },
  { name: "Miller", lat: -33.921, lng: 150.888 },
  { name: "Mittagong", lat: -34.447, lng: 150.447 },
  { name: "Belfield", lat: -33.894, lng: 151.083 },
  { name: "Mount Annan", lat: -34.056, lng: 150.769 },
  { name: "Dapto", lat: -34.506, lng: 150.793 },
  { name: "Mount Lewis", lat: -33.908, lng: 151.047 },
  { name: "Narellan Vale", lat: -34.048, lng: 150.746 },
  { name: "Old Guildford", lat: -33.862, lng: 150.974 },
  { name: "Oran Park", lat: -34.0065, lng: 150.7445 },
  { name: "Picnic Point", lat: -33.966, lng: 151.0 },
  { name: "Plumpton", lat: -33.748, lng: 150.842 },
  { name: "Regents Park", lat: -33.884, lng: 151.023 },
  { name: "Rosemeadow", lat: -34.093, lng: 150.783 },
  { name: "Minto", lat: -34.035, lng: 150.848 },
  { name: "Smithfield", lat: -33.849, lng: 150.931 },
  { name: "St Andrews", lat: -34.029, lng: 150.806 },
  { name: "Castle Hill", lat: -33.732, lng: 151.0 },
  { name: "St Helens Park", lat: -34.103, lng: 150.796 },
  { name: "St Marys", lat: -33.7665, lng: 150.7745 },
  { name: "Thomas Acres", lat: -34.079, lng: 150.806 },
  { name: "Villawood", lat: -33.872, lng: 150.976 },
  { name: "Warragamba", lat: -33.888, lng: 150.606 },
  { name: "Warnervale", lat: -33.236, lng: 151.434 },
  { name: "Beverly Hills", lat: -33.949, lng: 151.081 },
  { name: "Willmot", lat: -33.728, lng: 150.821 },
  { name: "Woolooware", lat: -34.053, lng: 151.142 },
  { name: "Yanderra", lat: -34.316, lng: 150.582 },
];

// The Straight Sight clinic location (shown with a distinct pin).
export const CLINIC_PIN = { name: "Straight Sight — Punchbowl", lat: -33.9289, lng: 151.0553 };
